<!-- 预离场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructureForThirdPark"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportPreCarOut",
                "enterTime": "20190715105048",
                "leaveCarLicenseNumber": "粤A02039D",
                "leaveChannelCode": "0006",
                "leaveChargeGroupCode": "公交车",
                "leaveTime": "20190715105814",
                "parkCode": "2KPGX140",
                "totalAmount": 0,
                "amountReceivable": 0,
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统主动推送车辆预离场信息到智慧停车开放平台",
                sdkcondition: "cmd='upThirdParkCarPreOut'",
                t_url: this.commonUrls.test + "upThirdParkCarPreOut",
                p_url: this.commonUrls.prod + "upThirdParkCarPreOut",
                precondition: "联系智慧停车管理员创建第三方车场",
                fitSystem: "第三方停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'leaveCarLicenseNumber', info2: '是', info3: 'String', info4: '出场车牌号' },
                        { info1: 'leaveChannelCode', info2: '是', info3: 'String', info4: '离场通道编号' },
                        { info1: 'leaveChargeGroupCode', info2: '否', info3: 'String', info4: '月卡规则编号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'leaveTime', info2: '是', info3: 'String', info4: '离场时间，yyyyMMddHHmmss' },
                        { info1: 'totalAmount', info2: '否', info3: 'Decimal', info4: '停车费用' },
                        { info1: 'amountReceivable', info2: '否', info3: 'Decimal', info4: '应收金额' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/upward/upThirdParkCarPreOut.vue